<template>
	<el-dialog
		title="信息核对"
		:visible.sync="dialogVisible"
		width="60%"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		top="4vh"
	>
		<div
			class="box-card"
			v-if="infoContent && Object.keys(infoContent).length"
		>
			<template
				v-if="
					infoContent.purchaseFrom !== 2 &&
						infoContent.productInfos &&
						infoContent.productInfos.length
				"
			>
				<el-row
					class="custom-container"
					v-for="item in infoContent.productInfos"
					:key="item.id+'q'"
				>
					<el-col :span="4">
						<div v-if="item.imageUrl">
							<el-image
								style="width: 100%; height: 100%;"
								:src="item.imageUrl"
								:preview-src-list="item.imageUrl.split(',')"
							></el-image>
						</div>
						<el-row
							type="flex"
							justify="center"
							align="middle"
							v-else
						>
							<el-button
								type="text"
								size="mini"
								@click="getOriginalImg(item)"
								>查看原图</el-button
							>
						</el-row>
					</el-col>
					<el-col :span="18" :offset="2">
						<div class="inform flex">
							<div class="title">亚马逊订单号：</div>
							<div>{{ infoContent.amazonOrderId }}</div>
						</div>

						<div class="inform flex">
							<div class="title">标题：</div>
							<a
								target="_blank"
								style="color: #7fb1ff"
								:href="item.sourceLink"
								>{{ item.title }}</a
							>
						</div>
						<!--            <div class="inform flex">-->
						<!--              <div class="title">SKU：</div>-->
						<!--              <div>{{ item.sku }}</div>-->
						<!--            </div>-->
						<el-row type="flex" justify="space-between">
							<div class="inform flex">
								<div
									class="title"
									style="font-size: 15px;"
								>
									数量：
								</div>
								<div
									style="color:red;font-size: 18px;font-weight: bold;"
								>
									{{ item.quantityOrdered }}
								</div>
							</div>
							<!-- <el-button type="text">打印（0）</el-button> -->
						</el-row>
						<el-row type="flex" justify="space-between">
							<div class="inform flex">
								<div
									class="title"
									style="font-size: 15px;"
								>
									订单状态：
								</div>
								<div
									style="color:red;font-size: 18px;font-weight: bold;"
								>
									{{ sondata.orderStatus }}
								</div>
							</div>
							<!-- <el-button type="text">打印（0）</el-button> -->
						</el-row>
						<el-row type="flex" style="align-items: center;">
							<el-tag
								v-if="sondata.outInterceptStatus === 1"
								type="danger"
								effect="dark"
								style="font-size: 18px;margin-right: 10PX;"
								>拦截</el-tag
							>
							<el-tag
								v-if="sondata.orderType === '4'"
								type="danger"
								effect="dark"
								style="font-size: 18px;"
								>COD</el-tag
							>
							<el-tooltip
								class="item"
								effect="dark"
								content="订单冻结"
								placement="bottom"
								v-if="sondata.isFreeze === 1"
							>
								<i
									class="element-icons hx-snow"
									style="font-size: 40px;color: #1296db;line-height: 40px;"
								></i>
							</el-tooltip>
						</el-row>
					</el-col>
				</el-row>
			</template>
			<el-row class="custom-container" v-else>
				<el-col :span="4" v-if="infoContent.imagesList">
					<el-image
						style="width: 100%; height: 100%;"
						:src="infoContent.imagesList[0]"
						:preview-src-list="infoContent.imagesList"
					></el-image>
				</el-col>
				<el-col :span="18" :offset="2">
					<div class="inform flex">
						<div class="title">库存编号：</div>
						<div>{{ infoContent.inventoryNo }}</div>
					</div>
					<!-- <div class="inform flex">
                        <div class="title">公司：</div>
                        <div>{{ infoContent.companyFullName }}</div>
          </div>-->
					<div class="inform flex">
						<div class="title">全称：</div>
						<div>{{ infoContent.productFullName }}</div>
					</div>
					<div class="inform flex">
						<div class="title">简称：</div>
						<div>{{ infoContent.productSimpleName }}</div>
					</div>
					<div class="inform flex">
						<div class="title">描述：</div>
						<div>{{ infoContent.productDescription }}</div>
					</div>
					<div class="inform flex">
						<div class="title">规格尺寸：</div>
						<div>{{ infoContent.inventorySku }}</div>
					</div>
					<el-row type="flex" justify="space-between">
						<div class="inform flex">
							<div class="title">预计数量：</div>
							<div>{{ infoContent.predictCount }}</div>
						</div>
						<!-- <el-button type="text">打印（0）</el-button> -->
					</el-row>
				</el-col>
			</el-row>
			<div
				class="custom-container"
				v-if="type !== 'out' && infoPurchase && infoPurchase.length"
			>
				<div style="width:100%;">
					<template v-for="item in infoPurchase">
						<div
							style="width:100%;"
							:key="item.purchaseNumber+'w'"
							v-if="![2, 7].includes(item.exceptionResult)"
						>
							<el-divider></el-divider>
							<el-row style="display: flex;">
								<div style="width:80%;">
									<el-row>
										<el-col :span="8">
											<div class="inform">
												采购单据号：{{
													item.purchaseNumber
												}}
											</div>
										</el-col>
										<el-col :span="8">
											<div class="inform">
												运单号：{{
													item.internalConveyNumber
												}}
											</div>
										</el-col>
									</el-row>
									<div
										class="inform"
										v-if="item.insertFrom == 0"
										style="font-weight: bold;font-size: 18px;color: red;"
									>
										海逊仓库核对详情：{{
											item.purchaseModel
										}}
									</div>
									<div
										class="inform"
										v-if="item.insertFrom !== 0"
										style="font-weight: bold;font-size: 18px;color: blue;"
									>
										海逊仓库核对详情：{{
											item.purchaseModel
										}}
									</div>
									<el-row>
										<el-col :span="8">
											<div class="inform">
												入库尺寸：{{
													item.purchaseSize
												}}
											</div>
										</el-col>
										<el-col :span="8">
											<div class="inform">
												入库重量：{{
													item.purchaseWeight
												}}
											</div>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="8">
											<div class="inform">
												材积重：{{ item.purchaseSize }}
											</div>
										</el-col>
										<el-col :span="8">
											<div class="inform">
												计费重：{{
													item.purchaseWeight
												}}
											</div>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="8">
											<div class="inform">
												货物等级：{{
													item.purchaseClass
												}}
											</div>
										</el-col>
										<el-col :span="8">
											<div
												class="inform"
												v-if="item.purchaseQuantity"
											>
												采购数量：{{
													item.purchaseQuantity
												}}
											</div>
										</el-col>
										<el-col
											:span="8"
											v-if="
												infoContent.purchaseFrom === 2
											"
										>
											<el-row type="flex" align="middle">
												<span>实际入库数量：</span>
												<el-input
													v-model="
														infoContent.actualCount
													"
													style="width:100px;"
												></el-input>
											</el-row>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="8">
											<el-row type="flex" align="middle">
												<div>
													采购单入库时间：{{
														item.putStorageTime
													}}
												</div>
											</el-row>
										</el-col>
									</el-row>
									<el-row v-if="item.checkResult === 2">
										<el-col :span="8">
											<el-row type="flex" align="middle">
												<div>
													采购单更新时间：{{
														item.updateTime
													}}
												</div>
											</el-row>
										</el-col>
									</el-row>
								</div>
								<div style="width:20%;">
									<img
										:src="pics"
										alt=""
										v-if="item.invalidStatus === 0"
										style="width:200px;"
									/>
								</div>
							</el-row>

							<el-row type="flex" justify="end">
								<el-button
									v-if="item.invalidStatus !== 0"
									:type="
										item.checkResult === 2 ? 'danger' : ''
									"
									:disabled="item.checkResult === 2"
									@click="openInfoError(item)"
									>信息报错
								</el-button>
								<el-button
									@click="print(item.id)"
									v-if="item.checkResult === 2"
									>打印报错单</el-button
								>
							</el-row>
						</div>
					</template>
				</div>
			</div>
		</div>
		<div v-else-if="infoData.productInfos && infoData.productInfos.length">
			<el-row
				class="custom-container"
				v-for="item in infoData.productInfos"
				:key="item.id+'e'"
			>
				<el-col :span="4">
					<div v-if="item.imageUrl">
						<el-image
							style="width: 100%; height: 100%;"
							:src="item.imageUrl"
							:preview-src-list="item.imageUrl.split(',')"
						></el-image>
					</div>
					<el-row type="flex" justify="center" align="middle" v-else>
						<el-button
							type="text"
							size="mini"
							@click="getOriginalImg(item)"
							>查看原图</el-button
						>
					</el-row>
				</el-col>
				<el-col :span="18" :offset="2">
					<div class="inform flex">
						<div class="title">亚马逊订单号：</div>
						<div>{{ item.amazonOrderId }}</div>
					</div>
					<div class="inform flex">
						<div class="title">标题：</div>
						<a
							target="_blank"
							style="color: #7fb1ff"
							:href="item.sourceLink"
							>{{ item.title }}</a
						>
					</div>
					<!--            <div class="inform flex">-->
					<!--              <div class="title">SKU：</div>-->
					<!--              <div>{{ item.sku }}</div>-->
					<!--            </div>-->
					<el-row type="flex" justify="space-between">
						<div class="inform flex">
							<div class="title">数量：</div>
							<div>{{ item.quantityOrdered }}</div>
						</div>
						<!-- <el-button type="text">打印（0）</el-button> -->
					</el-row>
				</el-col>
			</el-row>
		</div>
		<template
			v-if="
				infoData.inventoryOperates && infoData.inventoryOperates.length
			"
		>
			<div v-for="item in infoData.inventoryOperates" :key="item.id+'t'">
				<el-divider></el-divider>
				<el-row class="custom-container" type="flex" align="middle">
					<el-col :span="4">
						<el-image :src="item.imagesList[0]"></el-image>
					</el-col>
					<el-col :offset="1">
						<div class="inform flex">
							<span class="title">库存编号：</span
							>{{ item.inventoryNumber }}
						</div>
						<div class="inform flex">
							<span class="title">全称：</span
							>{{ item.productFullName }}
						</div>
						<div class="inform flex">
							<span class="title">仓库名称：</span
							>{{ item.warehouseName }}
						</div>
						<div class="inform flex">
							<span class="title">货架编号：</span
							>{{ item.shelfNumber }}
						</div>
						<div class="inform flex">
							<span class="title">使用数量：</span
							>{{ item.useCount }}
						</div>
						<div class="inform flex">
							<span class="title">出库时间：</span
							>{{ item.confirmTime }}
						</div>
						<div class="inform flex">
							<span class="title">规格尺寸：</span
							>{{ item.inventorySku }}
						</div>
						<div
							class="inform flex"
							v-if="item.insertFrom == 0"
							style="font-weight: bold;font-size: 18px;color: red;"
						>
							<span class="title">核对备注：</span
							>{{ item.purchaseDemandRemark }}
						</div>
						<div
							class="inform flex"
							v-if="item.insertFrom == 1"
							style="font-weight: bold;font-size: 18px;color: blue;"
						>
							<span class="title">核对备注：</span
							>{{ item.purchaseDemandRemark }}
						</div>
					</el-col>
				</el-row>
			</div>
		</template>
		<div class="custom-container" v-if="type === 'confirm'">
			<div style="width:100%;">
				<el-divider></el-divider>
				<!-- <el-col :span="3" :offset="1">
                      <el-button type="primary" @click="Add_Packing_materials">增加包材设置</el-button>
        </el-col>-->
				<el-row type="flex">
					<div class="inform" style="flex-shrink:0;line-height:50px;">
						包材设置：
					</div>
					<div style="width:90%;">
						<el-col
							class="inform"
							:span="20"
							style="padding: 10px 0px;"
							v-for="(item, index) in channelData.orderPackPrices"
							:key="index+'y'"
						>
							<el-col :span="5">
								<el-select
									v-model="item.packId"
									placeholder="请选择"
								>
									<el-option
										v-for="item in bagLists"
										:key="item.id+'u'"
										:label="item.priceName"
										:value="item.id"
									></el-option>
								</el-select>
							</el-col>
							<el-col :span="2" :offset="1">数量：</el-col>
							<el-col :span="2">
								<el-input v-model="item.packCount"></el-input>
							</el-col>
							<el-col :span="3" :offset="1"
								>{{ calcPrice(item) }}CNY</el-col
							>
							<el-col :span="4" :offset="1">
								<el-button
									type="primary"
									@click="Add_Packing_materials(index)"
									v-if="index === 0"
									>添加
								</el-button>
								<el-button
									type="danger"
									@click="Packingmaterialsdele(index)"
									v-if="
										index !== 0 &&
											channelData.orderPackPrices &&
											channelData.orderPackPrices.length >
												1
									"
									>删除
								</el-button>
							</el-col>
						</el-col>
					</div>
				</el-row>
			</div>
		</div>

		<div class="custom-container" style="margin-top:30px;">
			<div style="width:100%;">
				<el-row type="flex">
					<el-collapse style="width:100%;margin-top:30px;">
						<el-collapse-item title="物流内部备注">
							<div>
								<el-button
									type="primary"
									size="mini"
									@click="InRemarks = true"
									>添加备注</el-button
								>
							</div>
							<el-divider></el-divider>
							<div
								style="display: flex;justify-content: space-between;margin-top:15px;"
								v-for="(item, i) in this.RemarkList"
								:key="i+'o'"
							>
								<p style="width:10%;">{{ item.roleName }}</p>
								<p style="width:75%;">
									{{ item.remarkContent }}
								</p>
								<p style="width:15%;">{{ item.createTime }}</p>
							</div>
						</el-collapse-item>
					</el-collapse>
				</el-row>
			</div>
		</div>

		<el-dialog
			width="30%"
			title="添加物流内部备注"
			:visible.sync="InRemarks"
			append-to-body
		>
			<el-input v-model="remarksInput"></el-input>
			<div slot="footer" class="dialog-footer">
				<el-button @click="InRemarks = false">取 消</el-button>
				<el-button type="primary" @click="AddRemarks">确定</el-button>
			</div>
		</el-dialog>

		<div class="custom-container" style="margin-top:30px;">
			<div style="width:100%;">
				<div class="inform">
					<span style="margin-right:10px;">渠道信息：</span>
					<template v-if="type === 'confirm'">
						<el-button
							:type="infoData.channelResult === 2 ? 'danger' : ''"
							:disabled="infoData.channelResult === 2"
							@click="channelChange('error')"
							>渠道报错
						</el-button>
					</template>
				</div>
				<div v-if="infoChannel">
					<el-card
						shadow="hover"
						v-for="item in infoChannel"
						:key="item.id+'a'"
					>
						<el-row type="flex">
							<div class="channel-flex">
								<h4>渠道：</h4>
								<span v-if="item.type == 1">三态</span>
								<span v-if="item.type == 2">云途</span>
								<span v-if="item.type == 3">燕文</span>
								<span v-if="item.type == 4">第三方</span>
								<span v-if="item.type == 5">k5</span>
								<span v-if="item.type == 6">递四方</span>
								<span v-if="item.type == 7">云途（服装）</span>
								<span v-if="item.type == 8">泰嘉</span>
								<span v-if="item.type == 9">八达通</span>
								<span v-if="item.type == 10">云途A</span>
								<span v-if="item.type == 11">递四方A</span>
								<span v-if="item.type == 12">捷岸</span>
								<span v-if="item.type == 13">立德</span>
								<span v-if="item.type == 14">艾姆勒</span>
								<span v-if="item.type == 15">shopee物流</span>
								<span v-if="item.type == 16">ozon物流</span>
								<span v-if="item.type == 17">柏电</span>
                <span v-if="item.type == 18">柏电自有</span>
                <span v-if="item.type == 19">万立德</span>
								<span v-if="item.type == 20">浩亿达</span>
								<span v-if="item.type == 21">Cheer</span>
                <span v-if="item.type == 22">辰达通</span>
                <span v-if="item.type == 23">辰达通A</span>
								<span v-if="item.type == 24">浩亿达_厦门</span>
								<span v-if="item.type == 25">艾派</span>
								<span v-if="item.type == 26">艾派_厦门</span>
								<span v-if="item.type == 27">dealfy</span>
								<span v-if="item.type == 28">菜鸟</span>
								<span v-if="item.type == 29">艾派COD</span>
								<span v-if="item.type == 30">欧邮通</span>
								<span v-if="item.type == 31">菜鸟-海度</span>
								<span v-if="item.type == 32">速卖通物流</span>
								<span v-if="item.type == 33">Walmart_SWW</span>
								<span v-if="item.type == 34">商壹国际</span>
								<span v-if="item.type == 35">小包</span>
								<span v-if="item.type == 36">mercadolibre物流</span>
							</div>
							<div class="channel-flex">
								<h4>运单号：</h4>
								{{ item.conveyNumber }}
							</div>
							<div class="channel-flex">
								<h4>追踪号：</h4>
								{{ item.trackNumber }}
							</div>
							<div class="channel-flex">
								<h4>转单号：{{ item.transferOrderNumber }}</h4>
							</div>
						</el-row>
						<el-row type="flex" justify="space-between">
							<el-row type="flex">
								<div class="channel-flex">
									<h4>国家：</h4>
									{{ item.countryName }}
								</div>
								<div class="channel-flex">
									<h4>路线：</h4>
									{{ item.channelWay }}
								</div>
								<div class="channel-flex">
									<h4>时间：</h4>
									{{ item.createTime }}
								</div>
							</el-row>
							<div class="right-btn-container">
								<el-button
									class="padding0"
									type="text"
									@click="openPrintPage(item)"
									>打印({{ item.printfCount || 0 }})
								</el-button>
							</div>
						</el-row>
					</el-card>
				</div>
			</div>
		</div>
		<!-- <el-form inline style="margin-top: 20px;" v-if="type === 'enter'">
              <el-form-item label="实际入库数量">
                  <el-input v-model="actualCount"></el-input>
              </el-form-item>
    </el-form>-->

		<span slot="footer" class="dialog-footer">
			<el-button
				type="primary"
				@click="infoCheckDone"
				:loading="isDoneBtnLoding"
				v-if="type === 'confirm'"
			>
				<!-- :disabled="isDoneBtnDisabledConfirm" -->
				审核通过
			</el-button>
			<el-button
				type="primary"
				@click="infoCheckDone2"
				:loading="isDoneBtnLoding"
				v-else-if="type === 'enter'"
			>
				<!-- :disabled="isDoneBtnDisabledConfirm" -->
				审核通过
			</el-button>
			<el-button
				type="primary"
				@click="outWarehouseInfo"
				v-else
				:loading="isDoneBtnLoding"
				>出 库</el-button
			>
		</span>
		<el-dialog
			width="45%"
			title="请填写报错备注"
			:visible.sync="innerVisible"
			append-to-body
		>
			<el-upload
				multiple
				:action="action"
				list-type="picture-card"
				:on-success="handleAvatarSuccess"
				:on-remove="handleRemove"
				:headers="customHeaders"
			>
				<i class="el-icon-plus"></i>
			</el-upload>
			<el-row :gutter="20" style="margin-top: 10px;">
				<el-col :span="6" :offset="0">
					<el-select v-model="exceptionType" clearable>
						<el-option v-for="item in exceptionTypeOptions"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-col>
				<el-col :span="6" :offset="0" v-show="exceptionType">
					<strong>数量：</strong>
					<el-input-number v-model="exceptionQuantity" size="small" :min="1" :step="1">
					</el-input-number>
				</el-col>
				<!-- <el-col :span="6" :offset="0">
					<el-button type="success">新增</el-button>
					<el-button type="danger">删除</el-button>
				</el-col> -->
			</el-row>
			
			
			<el-input
				type="text"
				v-model="exceptionRemark"
				placeholder="请输入备注"
				style="margin: 10px 0;"
			></el-input>
			<el-select
				:value="abnormalContent"
				@change="setExceptionRemark"
				style="width: 100%;"
				filterable
			>
				<el-option
					v-for="item in listAbnormalWords"
					:key="item.id+'s'"
					:label="item.typeName"
					:value="item.content"
				></el-option>
			</el-select>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="infoChange('error')"
					>完 成</el-button
				>
			</span>
		</el-dialog>
		<el-dialog
			width="45%"
			title="请填写出库信息"
			:visible.sync="innerOutVisible"
			append-to-body
		>
			<el-table :data="tableDataOut" border style="width: 100%">
				<el-table-column label="国际运单号" align="center" width="240">
					<template slot-scope="scope">
						<el-input
							v-model="scope.row.conveyNumber"
							placeholder="请输入内容"
							readonly
						></el-input>
					</template>
				</el-table-column>
				<el-table-column label="物流渠道" align="center">
					<template slot-scope="scope">
						<el-input
							v-model="scope.row.channelName"
							placeholder="请输入内容"
							readonly
						></el-input>
					</template>
				</el-table-column>
				<!-- <el-table-column label="尺寸" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.channelSize" placeholder="请输入内容"></el-input>
          </template>
        </el-table-column>-->
				<el-table-column label="长" align="center">
					<template slot-scope="scope">
						<el-input v-model="scope.row.length"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="宽" align="center">
					<template slot-scope="scope">
						<el-input v-model="scope.row.width"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="高" align="center">
					<template slot-scope="scope">
						<el-input v-model="scope.row.height"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="重量" align="center">
					<template slot-scope="scope">
						<el-input v-model="scope.row.channelWeight"></el-input>
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button
					type="primary"
					@click="outWarehouse"
					:loading="loadingOutWarhouse"
					>完 成</el-button
				>
			</span>
		</el-dialog>

		<el-dialog :visible.sync="originalVisible" width="540px" append-to-body>
			<img style="width: 500px;height: 500px;" :src="originalImg" alt />
		</el-dialog>
	</el-dialog>
</template>
<script>
import { ajaxPost, Baseurl } from '@/api/api/api'
import { printInfo, increaseNum } from '@/utils/common.js'
import axios from 'axios'
export default {
	name: 'Informationcheck',
	props: {
		bagList: {
			type: Array,
			default() {
				return []
			},
		},
		UserInfo: Object,
	},
	data() {
		var pics = require('../../../assets/imags/pics.png')
		return {
			pics: pics,
			str: '',
			action: Baseurl + 'imageController/uploadImage',
			dialogVisible: false,
			innerVisible: false,
			innerOutVisible: false,
			infoData: {},
			currentIndex: 0,
			type: 'confirm',
			doneData: {},
			exceptionImages: [],
			exceptionRemark: '',
			isDoneBtnLoding: false,
			infoDataOrderId: 0,
			infoDataId: 0,
			tableDataOut: [],
			customHeaders: { token: localStorage.getItem('token') },
			channelData: {
				channelResult: '0',
				orderPackPrices: [],
			},
			loadingOutWarhouse: false,
			actualCount: '',
			row: {},
			originalVisible: false,
			originalImg: '',
			listAbnormalWords: [],
			abnormalContent: '',
			sondata: '',
			InRemarks: false,
			remarksInput: '',
			RemarkList: [],
			bagLists:[],
			exceptionType: '',
			exceptionQuantity: 1,
			exceptionTypeOptions: [
        {
          label: '缺件',
          value: 1
        },
        {
          label: '图货不符',
          value: 2
        },
        {
          label: '破损',
          value: 3
        },
        {
          label: '等件',
          value: 4
        },
        {
          label: '多件',
          value: 5
        },
        {
          label: '其他',
          value: 6
        }
      ]
		}
	},
	// watch: {
	// 	innerVisible(val) {
	// 		if (!val) {
	// 			this.exceptionType = ''
	// 			this.exceptionQuantity = 1
	// 			this.exceptionRemark = ''
	// 			this.abnormalContent = ''
	// 			this.exceptionImages = []
	// 		}
	// 	}
	// },
	computed: {
		infoContent() {
			// console.log(this.infoChannel)
			// console.log(JSON.parse(JSON.stringify(this.infoData)))
			if (this.type === 'enter') {
				return this.infoData
			} else if (this.type === 'confirm') {
				return (
					Object.keys(this.infoData).length &&
					this.infoData.purchases &&
					this.infoData.purchases[0]
				)
			} else if (this.type === 'out') {
				if (Object.keys(this.infoData).length) {
					// 创建副本避免修改原始数据
					const infoDataCopy = { ...this.infoData }
					infoDataCopy.productInfos = infoDataCopy.orderItems
					if (infoDataCopy.orderItems && infoDataCopy.orderItems[0]) {
						infoDataCopy.productInfos[0] = { ...infoDataCopy.orderItems[0] }
						infoDataCopy.productInfos[0].sku = infoDataCopy.orderItems[0].sellerSKU
					}
					infoDataCopy.purchaseQuantity = infoDataCopy.orderItems && infoDataCopy.orderItems[0] ? infoDataCopy.orderItems[0].quantityOrdered : 0
					return infoDataCopy
				}
			}
			return {}
		},
		infoPurchase() {
			//  console.log(JSON.parse(JSON.stringify(this.infoData)))
			// 订单确认有多条采购单，入库审核只有一条采购单，因为用的同一个组件方便遍历，所以返回必须是数组
			if (this.type === 'enter') {
				return [this.infoData]
			} else if (this.type === 'confirm') {
				return (
					Object.keys(this.infoData).length && this.infoData.purchases
				)
			}
			return []
		},
		infoChannel() {
			if (this.type === 'confirm') {
				const channels = this.infoData.orderChannels || []
				// 过滤掉无效的渠道记录：
				// 1. convey_number 为空或无效
				// 2. status 为 1 (作废)
				// 3. type 为空或无效
				return channels.filter(item =>
					item &&
					item.conveyNumber &&
					item.conveyNumber.toString().trim() !== '' &&
					item.status !== 1 &&
					item.type != null
				)
			} else if (this.type === 'out') {
				const channels = this.infoData.orderChannels || []
				// 过滤掉无效的渠道记录
				return channels.filter(item =>
					item &&
					item.conveyNumber &&
					item.conveyNumber.toString().trim() !== '' &&
					item.status !== 1 &&
					item.type != null
				)
			}
			return []
		},
		isDoneBtnDisabled() {
			return !Object.keys(this.doneData).length
		},
	},
	created() {
		this.str = JSON.parse(localStorage.getItem('role'))
	},
	methods: {
		async openPrintPage(item) {
			// 安全检查：确保必要字段存在
			if (!item || !item.type) {
				this.$message.error('渠道信息无效，无法打印')
				return
			}

			if (item.type == 12) {
				window.open('http://159.75.210.47:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
			} else if (item.type == 13) {
				window.open('http://129.204.214.77:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
			} else if (item.type == 15 || item.type == 16) {
				if (item.conveyNumberUrl != null && item.conveyNumberUrl != ''){
				window.open(item.conveyNumberUrl);
				} else {
				this.$message.error('暂无面单！')
				}
			} else if (item.type == 17) {
				window.open('http://47.96.42.132:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
			} else if (item.type == 18) {
				let API = Baseurl + 'baidian_order/getOrderLable'
				ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
				window.open(res.data)
				})
			} else if (item.type == 19) {
				let API = Baseurl + 'wanLeaderTypeController/getWanLeaderLabal'
				ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
				let data = JSON.parse(res.data)
				window.open(data.data)
				})
			} else if (item.type == 20 || item.type == 24) {
				window.open('http://1.14.254.116:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
			} else if (item.type == 21) {
				window.open('http://106.52.235.113:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
			} else if (item.type == 22) {
				let API = Baseurl + 'jiTuTypeController/getPrintUrl'
				ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
				let data = JSON.parse(res.data)
				window.open(data.data)
				})
			} else if (item.type == 23) {
				let API = Baseurl + 'udaTypeController/getUdaLabal'
				ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
				let data = JSON.parse(res.data)
				window.open(data.data)
				})
			} else if (item.type == 25 || item.type == 26) {
				if (item.conveyNumberUrl != null && item.conveyNumberUrl != ''){
				window.open(item.conveyNumberUrl);
				} else {
				window.open('http://159.75.205.97:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
				}
			} else if (item.type == 27) {
				if (item.conveyNumberUrl != null && item.conveyNumberUrl != ''){
				window.open(item.conveyNumberUrl);
				} else {
				let API = Baseurl + 'dealfyController/getWaybill'
				ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
					let data = JSON.parse(res.data)
					window.open(data.data)
				})
				}
			} else if (item.type == 28) {
				if (item.conveyNumberUrl != null && item.conveyNumberUrl != '') {
				window.open(item.conveyNumberUrl);
				} else {
				let API = Baseurl + 'cainiaoOrderController/getWaybill'
				ajaxPost(API, { conveyNumber: item.conveyNumber, type: 28 }, { responseType: 'blob' }).then((res) => {
					let data = JSON.parse(res.data)
					window.open(data.data)
				})
				}
			} else if (item.type == 29) {
				if (item.conveyNumberUrl != null && item.conveyNumberUrl != '') {
				window.open(item.conveyNumberUrl);
				}
			} else if (item.type == 30) {
				window.open('http://43.139.202.31:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
			} else if (item.type == 31) {
				if (item.conveyNumberUrl != null && item.conveyNumberUrl != '') {
				window.open(item.conveyNumberUrl);
				} else {
				let API = Baseurl + 'cainiaoOrderController/getWaybill'
				ajaxPost(API, { conveyNumber: item.conveyNumber, type: 31 }, { responseType: 'blob' }).then((res) => {
					let data = JSON.parse(res.data)
					window.open(data.data)
				})
				}
			} else if (item.type == 32) {
				if (item.channelWayEn == 'AE_GLOBAL_JIT') {
					let API = Baseurl + 'aliexpressSemiHostingCollection/getShippingMarkPdf'
				ajaxPost(API, { sellerId: this.infoData.sellerId, purchaseOrderNo: item.fulfillmentId }, { responseType: 'blob' }).then((res) => {
					let data = JSON.parse(res.data)
					window.open(data.data)
				})
				} else {
				let API = Baseurl + 'aliexpressLogistics/getPrintinfo'
				ajaxPost(API, { international_logistics_id: item.conveyNumber, sellerId: this.infoData.sellerId }, { responseType: 'blob' }).then((res) => {
					let data = JSON.parse(res.data)
					window.open(data.data)
				})
				}
			} else if (item.type == 33) {
				let API = Baseurl + 'walmartShipping/downloadLabel'
				// console.log(this.infoData);
				ajaxPost(API, { sellerId: this.infoData.sellerId, trackingNo: item.conveyNumber, carrierShortName: item.channelName }, { responseType: 'blob' }).then((res) => {
				let data = JSON.parse(res.data)
				window.open(data.data)
				})	
			} else if (item.type == 34) {
				let API = Baseurl + 'shangYiTypeController/getOrderLabel'
				ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
				let data = JSON.parse(res.data)
				window.open(data.data)
				})
			} else if (item.type == 35) {
				let API = Baseurl + 'xiaoBaoTypeController/getOrderLabel'
				ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
					let data = JSON.parse(res.data)
					window.open(data.data)
				})
			} else if (item.type == 36) {
				if (item.conveyNumberUrl) {
					let API = Baseurl + 'mercadolibre/getWaybill'
					axios.post(API,
						{ url: item.conveyNumberUrl, sellerId: item.sellerId },
						{ responseType: 'arraybuffer' }  // ← 关键
					).then((res) => {
						const blob = new Blob([res.data], { type: 'application/pdf' })
						window.open(URL.createObjectURL(blob))
					})
				} else {
					this.$message.info('该订单暂无数据！')
				}
			} else {
				await printInfo(item)
			}
			await increaseNum(item)
			item.printfCount += 1
		},
		init(type, row) {
			this.sondata = row
			console.log(this.sondata)
			this.type = type
			this.dialogVisible = true
			this.isDoneBtnLoding = false
			if (this.type === 'enter') {
				this.infoData = row
			} else if (this.type === 'confirm') {
				this.infoDataOrderId = row.orderId
				this.infoDataId = row.id
				// this.infoData.orderId = row.orderId;
				this.getInfo()
				this.channelData.channelResult = '0'
				this.channelData.orderPackPrices = []
				for(var i=0;i<this.bagList.length;i++){
					if(this.bagList[i].sellerType===row.source){
						this.bagLists.push(this.bagList[i]);
					}
				}
				this.renderComponent=true;
				let packId = null
				if (this.bagList.length == 0) {
					packId = null
				} else {
					packId = this.bagLists.find(
						(item) => item.defaultStatus === 1
					).id
				}
				this.channelData.orderPackPrices.push({
					orderId: this.infoDataOrderId,
					packId,
					packCount: 1,
				})
			} else if (this.type === 'out') {
				this.row = row
				this.getOutInfo()
			}
			this.doneData = {}
			this.RemarkListAjax()
		},
		close() {
			this.dialogVisible = false
			this.innerOutVisible = false
			this.isDoneBtnLoding = false
			this.infoData = {}
		},
		getInfo() {
			const API = Baseurl + 'logisticsController/getOrderDetailsById'
			const paramsData = {
				purchaseDemandId: this.infoDataId,
			}
			ajaxPost(API, paramsData).then((res) => {
				//   console.log(JSON.parse(JSON.stringify(res.data.data)))
				const { code, data } = res.data
				if (code === 200) {
					this.infoData = { ...this.infoData, ...data }
				}
			})
		},

		getOutInfo(row) {
			const { orderId, id } = this.row
			const API = Baseurl + 'logisticsController/getOutStockDetails'
			const paramsData = { orderId, id }
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.infoData = data
				}
			})
		},
		WarehousingDetermine() {
			this.dialogVisible = false
		},
		edit(item) {
			item.disabled = false
			item.infrom_editType = false
			item.infrom_PreservationType = true
		},
		Preservation(item) {
			item.disabled = true
			item.infrom_editType = true
			item.infrom_PreservationType = false
		},
		// 包材设置
		Add_Packing_materials() {
			const param = {
				orderId: this.infoDataOrderId,
				packId: this.bagList.find((item) => item.defaultStatus === 1)
					.id,
				packCount: 1,
			}
			this.channelData.orderPackPrices.push(param)
		},
		// 删除
		Packingmaterialsdele(index) {
			if (this.channelData.orderPackPrices.length > 1) {
				this.channelData.orderPackPrices.splice(index, 1)
				this.$message('删除成功')
			} else {
				this.$message('此包材设置必须最少保留1条')
			}
		},
		handleAvatarSuccess(response, file, fileList) {
			this.exceptionImages = fileList
		},
		handleRemove(file, fileList) {
			this.exceptionImages = fileList
		},
		openInfoError(item) {
			this.doneData.id = item.id
			this.doneData.orderId = item.orderId

			const API =
				Baseurl +
				'abnormalCommonWordController/selectAbnormalCommonWordList'
			ajaxPost(API).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listAbnormalWords = data
					this.innerVisible = true
				}
			})
		},
		setExceptionRemark(e) {
			this.exceptionType = this.listAbnormalWords.filter(x => x.content == e)[0].exceptionType
			let exceptionQuantity = this.listAbnormalWords.filter(x => x.content == e)[0].useQuantity
			if (exceptionQuantity) {
				this.exceptionQuantity = exceptionQuantity
			}
			this.exceptionRemark = e
			this.abnormalContent = ''
		},
		// 信息报错 信息确认
		infoChange(type = 'error') {
			if (!this.exceptionRemark) {
				this.$message.warning('未填写异常原因')
				return
			}
			this.doneData.checkResult = '2'
			this.doneData.exceptionImages = this.exceptionImages.map(
				(item) => item.response.data
			)
			this.doneData.exceptionRemark = this.exceptionRemark
			this.$set(this.doneData, 'exceptionQuantity', this.exceptionQuantity)

			const API = Baseurl + 'logisticsController/purchaseConfirm'
			const paramsData = {
				roleId: this.UserInfo.rid,
				companyId: this.UserInfo.company_id,
				exceptionType: this.exceptionType,
				...this.doneData,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.innerVisible = false
					this.getInfo()
					this.$message.success('操作成功')
				} else {
					this.$message.error(data.message)
				}
			})
		},
		// 渠道信息 确认或报错
		channelChange(type) {
			const handleRequest = () => {
				const API =
					Baseurl + 'logisticsController/confirmOrderChannelResult'
				const paramsData = {
					id: this.infoDataId,
					channelResult: '2',
				}
				ajaxPost(API, paramsData).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.getInfo()
						this.$message.success('操作成功')
					}
				})
			}
			this.$confirm('您确定要修改该货物的渠道信息吗？', '提示')
				.then(() => {
					handleRequest()
				})
				.catch(() => {
					this.$message('取消操作')
				})
		},
		infoCheckDone() {
			for (const item of this.infoChannel) {
				if (item.printfCount <= 0) {
					this.$alert('存在未打印的订单！', '提示')
					return
				}
			}

			this.$confirm('是否确认', '提示')
				.then(() => {
					console.log('确定')
					//   return;
					this.isDoneBtnLoding = true
					// this.channelData.id = this.infoData.purchaseDemandId;
					const data = {
						id: this.infoData.purchaseDemandId,
						orderPackPrices: this.channelData.orderPackPrices,
					}
					this.$emit('channelChangeConfirm', data)
				})
				.catch(() => {
					console.log('取消')
					this.$message('取消操作')
				})
		},
		infoCheckDone2() {
			if (!(this.infoContent.actualCount > -1)) {
				this.$message.warning('请填入实际入库数量')
				return
			}
			this.$confirm('是否确认', '提示')
				.then(() => {
					this.isDoneBtnLoding = true
					// this.channelData.id = this.infoData.purchaseDemandId;
					const data = {
						id: this.infoData.id,
						actualCount: this.infoContent.actualCount,
					}
					this.$emit('channelChangeConfirm2', data)
				})
				.catch(() => {
					this.$message('取消操作')
				})
		},
		// 出库信息填写
		outWarehouseInfo() {
			this.innerOutVisible = true
			this.tableDataOut = this.infoChannel.map((item, index) => ({
				length: '1',
				width: '1',
				height: '1',
				conveyNumber: item.conveyNumber,
				channelWeight: '',
				channelName: item.channelName,
			}))
		},
		// 点击出库
		outWarehouse() {
			const data = this.tableDataOut
			for (const item of data) {
				for (const key in item) {
					if (!item[key]) {
						this.$message.warning('请将信息填写完整')
						return
					}
				}
			}
			this.loadingOutWarhouse = true
			this.$emit('confirm', data)
		},
		calcPrice(item) {
			console.log(this.bagList);
			let { packId, packCount = 1 } = item
			// console.log(packId);
			if (!packId) return 0
			const price = this.bagList.find((itemS) => itemS.id === packId)
				.priceValue
			return price * packCount
		},
		getOriginalImg(item) {
			// console.log(item)
			const API = Baseurl + 'productController/selectImagesByChildSku'
			const paramsData = {
				childSku: item.sku,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data, message } = res.data
				if (code === 200) {
					this.originalImg = data
					this.originalVisible = true
				} else {
					this.$message.error(message)
				}
			})
		},
		RemarkListAjax() {
			const API =
				Baseurl + 'logisticsRemarkController/selectLogisticsRemarkList'
			const paramsData = {
				orderId: this.sondata.orderId,
			}
			ajaxPost(API, paramsData).then((res) => {
				if (res.data.code === 200) {
					this.RemarkList = res.data.data
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		AddRemarks() {
			const API =
				Baseurl + 'logisticsRemarkController/insertLogisticsRemark'
			const paramsData = {
				orderId: this.sondata.orderId,
				remarkContent: this.remarksInput,
				amazonOrderId: this.sondata.amazonOrderId,
				roleId: this.str.rid,
				companyId: this.str.company_id,
			}
			ajaxPost(API, paramsData).then((res) => {
				if (res.data.code === 200) {
					this.$message({
						type: 'success',
						message: '添加物流内部备注成功',
					})
					this.RemarkListAjax()
				} else {
					this.$message.error(res.data.data)
				}
				this.remarksInput = ''
				this.InRemarks = false
			})
		},
		print(val) {
			const API = Baseurl + 'purchasePdfPrintController/pdfPurchasePrint'
			const paramsData = {
				id: val,
			}
			ajaxPost(API, paramsData).then((res) => {
				if (res.data.code === 200) {
					window.open(res.data.data, '_blank')
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
	},
}
</script>
<style lang="scss" scoped>
.custom-container {
	padding: 0 20px;
	display: flex;
	align-items: center;
}

.inform {
	line-height: 30px;

	&.flex {
		display: flex;

		.title {
			flex-shrink: 0;
			font-weight: bold;
		}
	}
}

.right-btn-container {
	display: flex;
	justify-content: flex-end;
}

.el-popover {
	position: absolute;
	background: #fff;
	min-width: 200px;
	border: 1px solid #ebeef5;
	padding: 12px;
	left: 40%;
	right: 0%;
	top: -17%;
	color: #606266;
	line-height: 1.4;
	text-align: justify;
	font-size: 14px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	display: none;
	z-index: 9998;

	img {
		width: 90%;
	}
}

.padding0 {
	padding: 0;
}

.channel-flex {
	display: flex;
	margin-right: 20px;
}
</style>
